import _clamp from 'lodash/clamp';

export default function minMaxValue(value, minValue, maxValue) {
	const max = maxValue || maxValue === 0 ? maxValue : value;
	const min = minValue || minValue === 0 ? minValue : Math.min(value, max);
	return _clamp(value, min, max);
}
